import type { Program } from "../shared/programMocks";

const LOCAL_DRAFT_PROGRAM_PREFIX = "new-program-";

export function isLocalDraftProgram(program: Program): boolean {
    return program.id.startsWith(LOCAL_DRAFT_PROGRAM_PREFIX) && program.status === "in_progress";
}

export function mergeClientProgramRailState(
    currentPrograms: Program[],
    livePrograms: Program[],
    pendingDraftIds: ReadonlySet<string> = new Set()
): Program[] {
    const nextPrograms: Program[] = [];
    const seenProgramIds = new Set<string>();

    for (const program of currentPrograms) {
        if (!isLocalDraftProgram(program) || pendingDraftIds.has(program.id)) {
            continue;
        }
        nextPrograms.push(program);
        seenProgramIds.add(program.id);
    }

    for (const program of livePrograms) {
        if (seenProgramIds.has(program.id)) {
            continue;
        }
        nextPrograms.push(program);
        seenProgramIds.add(program.id);
    }

    return nextPrograms;
}
